module.exports = __webpack_public_path__ + "img/monterey_pulley_lift.ae3839ae.png";